'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var Divider = require('@narvar/nth-bit-divider');
var nthBitHeader = require('@narvar/nth-bit-header');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);

// Note: This type should come directly from useSettings, but it's formal type is currently any.

const SectionDivider = ({
  featureName,
  sectionDividerId
}) => {
  const {
    sectionDividers
  } = nthHookSettings.useSettings();
  const {
    sectiondividerPrimaryNone
  } = nthHookTheme.useTheme();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  React.useEffect(() => {
    if (!(sectionDividers && sectionDividers[sectionDividerId])) return;
    logEvent({
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_SECTION_DIVIDER,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_SECTION_DIVIDER,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER,
      feature: featureName,
      eventId: sectionDividerId,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_SECTION_DIVIDER
    });
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [sectionDividers, sectionDividerId]);
  if (!(sectionDividers && sectionDividers[sectionDividerId])) return null;
  const {
    title,
    divider = false
  } = sectionDividers[sectionDividerId];
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      minHeight: '5rem',
      ...sectiondividerPrimaryNone
    },
    "data-test": "sectionDividerContainer"
  }, title && /*#__PURE__*/React__default["default"].createElement(nthBitHeader.BigHeader, {
    featureName: featureName
  }, title)), divider && /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], {
    featureName: featureName
  }));
};
var SectionDivider$1 = nthHookSettings.withSettingsProvider(nthHookTheme.withThemeProvider(SectionDivider, {
  themeTokens: ['sectiondividerPrimaryNone']
}), {
  settingsRequested: 'sectionDividers'
});

exports["default"] = SectionDivider$1;
